import {
  Box,
  CircularProgress,
  Stack,
  Typography,
} from '@mui/material';
import { Navigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { listIndustrialCostProductionLinesConfig } from '../services/industrialCostService';
import { getIndustrialWorkflowsContext } from '../../industrialWorkflows/services/industrialWorkflowsService';

function hasPermission(
  permissions: string[] | undefined,
  permission: string,
) {
  return Boolean(permissions?.includes(permission));
}

export default function IndustrialCostFactoryEntryPage() {
  const productionLinesQuery = useQuery({
    queryKey: ['industrial-cost-production-config-lines-active'],
    queryFn: async () => {
      const rows = await listIndustrialCostProductionLinesConfig();

      return rows.filter((line) => line.is_active);
    },
    retry: false,
  });

  const workflowsContextQuery = useQuery({
    queryKey: ['industrial-workflows-context'],
    queryFn: getIndustrialWorkflowsContext,
    retry: false,
  });

  const isResolving =
    productionLinesQuery.isLoading
    || workflowsContextQuery.isLoading;

  if (isResolving) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          bgcolor: '#020617',
          color: '#f8fafc',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: 2,
        }}
      >
        <Stack spacing={1.5} alignItems="center">
          <CircularProgress size={28} />
          <Typography
            sx={{
              color: '#94a3b8',
              fontWeight: 700,
              fontSize: '0.92rem',
            }}
          >
            Preparando tu puesto de trabajo...
          </Typography>
        </Stack>
      </Box>
    );
  }

  const activeProductionLines =
    productionLinesQuery.data ?? [];

  const workflowsPermissions =
    workflowsContextQuery.data?.permissions ?? [];

  const canViewWorkflowTasks =
    workflowsContextQuery.data?.has_access === true
    && hasPermission(
      workflowsPermissions,
      'workflows:tasks:view',
    );

  if (
    productionLinesQuery.isSuccess
    && activeProductionLines.length === 0
    && canViewWorkflowTasks
  ) {
    return (
      <Navigate
        to="/industrial-workflows/operator"
        replace
      />
    );
  }

  return (
    <Navigate
      to="/factory/operator"
      replace
    />
  );
}